import {
  Application,
  CompanyDetails,
} from '../application-config/application-config';
import { OptionalAssets } from '../assets/assets';
import {
  BillingInformation,
  DiscountMetadata,
  ProductMetadataMap,
} from '../cart';
import { TimeIdentifiers } from '../common/identifiers';
import { PaymentProviderName, SupportedCurrencies } from '../payment';
import { ProductType } from '../product/product';

export type PurchaseType = PurchaseEntity & TimeIdentifiers;

export type PaymentDiscountMetadata = DiscountMetadata & {
  totalDiscount?: number;
  convertedTotalDiscount?: number;
};

export interface PaymentData {
  convertedPrice: number;
  currency: SupportedCurrencies;
  discountMetadata?: PaymentDiscountMetadata;
  convertedPriceUsd: number;
  originPrice: number;
  currencyRate: number;
  tradingSystemFee?: number;
}

export interface PurchaseEntity {
  userId: string;
  purchaseId: string;
  snapshotId: string;
  asset: OptionalAssets;
  items: PurchaseItemEntity[];
  paymentData: PaymentData;
  billingInformation: BillingInformation;
  status: PurchaseStatus;
  providerData: ProviderData;
  project?: Application; // Optional for backward compatibility
}

export type PurchaseItemEntity<T extends ProductType = ProductType> = {
  productId: string;
  productType: T;
  unitPrice: number;
  quantity: number;
  metadata: ProductMetadataMap[T];
};

export enum PurchaseStatus {
  Pending = 'pending',
  Completed = 'completed',
  Failed = 'failed',
  Canceled = 'canceled',
  Refunded = 'refunded',
}

export type ProviderData = {
  name: PaymentProviderName;
  transactionId?: string;
  cardHolderName?: string;
  paymentSessionId?: string;
  serialNumber?: string;
  transactionType?: string;
};

// export interface PurchaseAdditionalInformation {
//   agreedToTerms: boolean;
//   agreedCardName?: boolean;
//   declaredInformationIsCorrect: boolean;
//   googleClientId: string;
//   sessionId: string;
// }

// export type PurchaseUserInformation = Exclude<UserInformation, 'userId'> &
//   PurchaseAdditionalInformation;

export interface InvoiceDisplayData {
  // Purchase Details
  purchase: PurchaseType;

  // Company Details
  companyDetails: CompanyDetails;
}

export interface PurchaseStatusResponse {
  purchaseId?: string;
  status: PurchaseStatus;
  currency?: SupportedCurrencies;
  amount?: number;
  updatedAt: string; // ISO string (serialized Date from TCP/JSON)
  createdAt: string; // ISO string (serialized Date from TCP/JSON)
}

export interface RepayResponse {
  asset: OptionalAssets;
  success: boolean;
}

export interface PurchaseMetrics {
  totalOrders: number;
  youSaved: number;
  hubCreditsUsed: number;
  activePrograms: number;
}
